import ToastBase from './toast-base';

export default ToastBase;
